if ($('.rellax').length !== 0) {
  var rellax = new Rellax('.rellax');
}
